<!--  -->
<template>
  <div>
    <div class="select_box">
      <div>
        <div class="outerLayer_groupingArea">
          <div class="left">
            <span class="left_title">是否公用</span>
            <ul class="left_ul">
              <li class="ul_li" :class="{active:pageIfon.is_public == 1}" @click="lewrurl(1)">否</li>
              <li class="ul_li" :class="{active:pageIfon.is_public == 2}" @click="lewrurl(2)">是</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
        <div class="outerLayer_groupingArea" style="margin:15px 0px">
          <div class="left">
            <span class="left_title">图片类型</span>
            <ul class="left_ul">
              <li
                v-for="itemr,index in typelist"
                :key="index"
                :class="{active:pageIfon.business_type == itemr.type}"
                class="ul_li"
                @click="wrw(itemr.type)"
              >{{ itemr.name }}</li>
            </ul>
          </div>
          <!-- <div class="right">
        <span class="right_span">新建</span>
        <span class="right_span">管理</span>
      </div> -->
        </div>
      </div>
      <div>
        <el-upload
          v-if="typer==='1'"
          class="upload-demo"
          drag
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="changeUpload"
        >
          <!-- <div>
            <i class="el-icon-upload" />
            <span>上传</span>
          </div> -->
          <el-button type="success" icon="el-icon-upload">上传</el-button>
        </el-upload>
        <el-button v-else type="success" icon="el-icon-upload" size="small" @click="$refs.file.click()">上传<input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change="uploadPictures"></el-button>
      </div>
    </div>

    <div v-if="imgarrs.length!=0" class="imgbox">
      <div v-for="(item,index) in imgarrs" :key="index" class="imgboxew">
        <img :src="item.path" class="item-img" @click="handitem(item.path,item.id)">
      </div>
    </div>
    <div v-else class="zanewr">暂无数据</div>

    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog title="图片剪裁" :visible.sync="caidialogVisible" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :fixed="option.fixed"
            :center-box="option.centerBox"
            :info-true="option.infoTrue"
            :fixed-box="option.fixedBox"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :fixed-number="option.fixedNumber"
            :enlarge="option.enlarge"
            :mode="option.mode"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="finish">确认</el-button>
        <el-button @click="quxiao">取 消</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import { getMaterialLibraryList, materialroadtype, newMateriallist } from '@/api/sourceMaterial.js'
import getNowDate from '@/utils/mixins/convertToHump.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
export default {
  components: {
    PaginationRight
  },
  mixins: [getNowDate],
  props: {
    imgarr: {
      type: Array,
      default: () => {
        return []
      }
    }

  },
  data() {
    return {
      imgarrs: [],
      typer: null,
      total: null,
      pageIfon: {
        type: 1,
        page: 1,
        pageSize: 10,
        is_public: 1,
        business_type: 0
      },
      typelist: [],
      token: null,
      temporary: null,
      loading: false,
      caidialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        // outputType: 'jpeg', // 裁剪生成图片的格式     :output-type="option.outputType"
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 640, // 默认生成截图框宽度
        autoCropHeight: 640, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式  contain , cover, 100px, 100% auto
      },
      fileinfo: null
    }
  },
  created() {
    this.mawlist()
  },
  mounted() {

  },
  methods: {
    // 获取token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    // 获取素材库类型列表
    async mawlist() {
      const data = await materialroadtype()
      this.typelist = data.data
      console.log('类型data', data)
    },
    // 获取素材库列表
    getlist() {
      getMaterialLibraryList(this.pageIfon).then(res => {
        console.log('res', res)
        this.imgarrs = res.data.list
        this.total = res.data.total
      })
    },
    handitem(img, key) {
      if (this.typer === '1') {
        console.log('111')
        this.$emit('clickicon', img, key)
      } else if (this.typer === '2') {
        console.log('222')
        this.$emit('kefuicon', img, key)
      } else {
        console.log('333')
        this.$emit('imgcallback', img, key)
      }
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.getlist()
    },
    parentHandleclick(e) {
      console.log('parentHandleclick', e)
      this.typer = e
      this.getlist()
      this.getQiniuToken()
    },
    lewrurl(id) {
      this.pageIfon.page = 1
      this.pageIfon.is_public = id
      this.getlist()
    },
    wrw(id) {
      this.pageIfon.page = 1
      this.pageIfon.business_type = id
      this.getlist()
    },
    async uploadPictures(e) {
      console.log('uploadPictures', e)
      const that = this
      const arr = []
      for (let i = 0; i < e.target.files.length; i++) {
        const fileIfon = e.target.files[i]
        const img = new Image()
        const temporary = e.target.files.length > 1 ? '多张' : window.URL.createObjectURL(fileIfon)
        temporary !== '多张' && (img.src = temporary)
        this.temporary = temporary
        const options = {
          quality: 0.62,
          noCompressIfLarger: false,
          maxWidth: 1000,
          maxHeight: 1000
        }
        const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }

        if (ftype !== '.gif') {
          qiniu.compressImage(fileIfon, options).then(data => {
            const observable = qiniu.upload(data.dist, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
              fname: fileIfon.name // 文件名
            }, {
              useCdnDomain: true // cdn域名加速
            })
            observable.subscribe({
              next() { },
              error(err) {
                console.log(err)
              },
              complete: (data) => {
                console.log('data------111', data)
                arr.push({
                  type: 1,
                  height: img.height,
                  width: img.width,
                  size: fileIfon.size,
                  key: data.key
                })
                if (arr.length === e.target.files.length) {
                  // this.$refs.men.style.height = 0
                  setTimeout(async() => {
                    await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: this.pageIfon.is_public })
                    await this.getlist()
                    this.temporary = null
                  }, 500)
                  // console.log(arr)
                }
              }

            })
          })
        } else {
          const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
            fname: fileIfon.name // 文件名
          }, {
            useCdnDomain: true // cdn域名加速
          })
          observable.subscribe({
            next() { },
            error(err) {
              console.log(err)
            },
            complete: (data) => {
              console.log('data------222', data)
              arr.push({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              })
              if (arr.length === e.target.files.length) {
                // this.$refs.men.style.height = 0
                setTimeout(async() => {
                  await newMateriallist({ list: arr, business_type: that.pageIfon.business_type, is_public: this.pageIfon.is_public })
                  await this.getlist()
                  this.temporary = null
                }, 500)
                // console.log(arr)
              }
            }

          })
        }
        // const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
      }
    },
    // 上传按钮   限制图片大小 裁剪的上传
    changeUpload(file, fileList) {
      console.log('changeUpload', file, fileList)
      // const isLt5M = file.size / 1024 / 1024 < 5
      // if (!isLt5M) {
      //   this.$message.error('上传文件大小不能超过 5MB!')
      //   return false
      // }

      // const fileIfon = e.target.files[i]
      const img = new Image()
      console.log('img.height', img.height, 'img.width', img.width)
      const url = URL.createObjectURL(file.raw)
      console.log('url', url)
      this.fileinfo = file
      console.log('file', file)
      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = url
        // this.testsrc = url
        this.caidialogVisible = true
      })
    },
    // 截图成功上传图片
    finish() {
      this.$refs.cropper.getCropBlob((data) => {
        const arr = []
        const img = new Image()
        console.log('data', data)
        // var sizebig = data.size
        const ftype = this.fileinfo.name.substr(this.fileinfo.name.lastIndexOf('.')) // 截取文件格式
        const extension = ftype === '.jpg'
        const extension2 = ftype === '.png'
        const extension3 = ftype === '.jpeg'
        const extension4 = ftype === '.gif'
        // eslint-disable-next-line eqeqeq
        if (!extension && !extension2 && !extension3 && !extension4) {
          this.$message({
            message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
            type: 'error'
          })
          return
        }
        const observable = qiniu.upload(data, `workwechat_avatar/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`, this.token, {
          fname: this.fileinfo.name // 文件名
        }, {
          useCdnDomain: true // cdn域名加速
        })
        observable.subscribe({
          next() { },
          error(err) {
            console.log(err)
          },
          complete: (data) => {
            console.log('上传图片data=----', data)
            console.log(' this.avatarlist', this.avatarlist)
            arr.push({
              type: 1,
              height: img.height,
              width: img.width,
              size: this.fileinfo.size,
              key: data.key
            })
            newMateriallist({
              list: arr,
              business_type: this.pageIfon.business_type,
              is_public: this.pageIfon.is_public
            }).then(response => {
              console.log('response', response)
              this.$message({
                message: '上传成功',
                type: 'success'
              })
              this.getlist()
              this.temporary = null
            })

            this.caidialogVisible = false
          }
        })
      })
    },
    quxiao() {
      // this.testsrc = ''
      this.caidialogVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
/* @import url(); 引入css类 */
*{

  list-style-type: none;
  box-sizing: border-box;
}
.active{
  border: 1px solid #67C23A;
  color: #67C23A;
}
   .outerLayer_groupingArea{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
        .left{
          display: flex;
          align-items: center;
           .left_title{
              font-size: 14px;
           }
           .left_ul{
             display: flex;
             align-items: center;
             .ul_li{
              list-style-type:none;
              // padding: 6px 10px;
              padding: 7px 10px 5px 10px;
              font-size: 13px;
              cursor: pointer;
              border-radius: 6px;
              &:not(.active):hover{
               background-color: rgb(230, 230, 230);
              }
              .active{
                background-color: rgb(202, 202, 202);
              }
             }
           }
        }
        .right{
           .right_span{
             font-size: 12px;
             padding: 6px 10px;
             border-radius: 5px;
             display: inline-block;
             cursor: pointer;
             &:hover{
               background-color: rgb(230, 230, 230);
             }
           }
        }
   }
.imgbox{
  display: flex;
  flex-wrap: wrap;
}
.item-img{
 width: 150px;
 height: 150px;
 margin-right: 15px;
}
.imgboxew{
  width: 150px;
  height: 150px;
  margin-right: 20px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
}
.zanewr{
  text-align: center;
  margin: 10px 0px;
}
.select_box{
  display: flex;
  // align-items: center;
  justify-content: space-between;
  padding-right: 30px;
}
.cropper-content .cropper {
        width: auto;
        height: 300px;
}
.upload-demo /deep/ .el-upload-dragger{
      width: 89px;
      height: 36px;
      border: none;
      // background-color: #13ce66;
}
.upload-demo /deep/ .el-button--medium{
  width: 89px;
  height: 36px;
  padding: 0;
}
.upload-demo /deep/ .el-upload-dragger .el-icon-upload {
      font-size: 14px;
      margin: 0;
      line-height: 14px;
      color: white;
}
@media (max-width: 768px){
  .select_box{
    width:100%;
    height:40vw;
  }
  .outerLayer_groupingArea{
    margin-bottom:10vw;
  }
  // .left{
  //   margin-bottom:10vw;
  // }
  .outerLayer_groupingArea .left{
    width:100%;
    overflow:auto;
  }
  .left_title{
    width:25vw;
  }
  .left_ul{
    padding:0;
    padding-left:5vw;
    width:50%;
    overflow:auto;
  }
  .imgbox{
    gap:5vw;
    justify-content: space-between;
  }

  .imgboxew{
    width:22vw;
    height:22vw;
    margin:0vw;
    border-radius:3vw;
  }
  .item-img{
    width:100%;
    height:100%;
    border-radius:3vw;
  }
}
</style>
